<template>
  <div>
    <div class="fix-wrapper">
      <breadcrumb
        :crumbs="[$t('menu.rentTemplates'), $t('text.list')]"
      ></breadcrumb>
      <div class="container">
        <el-form
          ref="printTemplateForm"
          :model="printTemplate"
          label-width="80px"
          size="small"
        >
          <div class="pd20">
            <fieldset>
              <legend>{{ $t("text.baseInfo") }}</legend>
              <el-row :gutter="20">
                <el-col :span="8">
                  <el-form-item
                    :label="$t('text.name')"
                    :prop="'name'"
                    :rules="[
                      {
                        required: true,
                        message: $t('rules.required', [$t('text.name')]),
                        trigger: 'blur',
                      },
                    ]"
                  >
                    <el-input size="small" v-model.trim="printTemplate.name" />
                  </el-form-item>
                </el-col>
              </el-row>
            </fieldset>
            <el-row :gutter="20">
              <el-col :span="16">
                <fieldset class="mgb15">
                  <legend>
                    {{ $t("text.template") }}
                    <span class="font10 orange">
                      {{ $t("prompt.rentTemplatePrompt") }}
                    </span>
                  </legend>
                  <tinymce-editor
                    ref="editor"
                    v-model="printTemplate.content"
                    :height="1100"
                    :menubar="true"
                  />
                </fieldset>
              </el-col>
              <el-col :span="8">
                <fieldset class="mgb15">
                  <legend>订单{{ $t("text.reference") }}</legend>
                  <vxe-table
                    :data="references"
                    row-id="id"
                    ref="recordsTable"
                    class="recordsTable"
                    size="mini"
                    resizable
                    border
                    highlight-hover-row
                    auto-resize
                    :scroll-y="{ enabled: false }"
                  >
                    <vxe-table-column
                      type="seq"
                      :title="$t('text.seq')"
                      width="50"
                    ></vxe-table-column>
                    <vxe-table-column field="name" :title="$t('text.name')" />
                    <vxe-table-column
                      field="value"
                      :title="$t('text.reference')"
                    />
                  </vxe-table>
                </fieldset>
                <fieldset class="mgb15">
                  <legend>订单项{{ $t("text.reference") }}</legend>
                  <vxe-table
                    :data="referencesItem"
                    row-id="id"
                    ref="recordsTable"
                    class="recordsTable"
                    size="mini"
                    resizable
                    border
                    highlight-hover-row
                    auto-resize
                    :scroll-y="{ enabled: false }"
                  >
                    <vxe-table-column
                      type="seq"
                      :title="$t('text.seq')"
                      width="50"
                    ></vxe-table-column>
                    <vxe-table-column field="name" :title="$t('text.name')" />
                    <vxe-table-column
                      field="value"
                      :title="$t('text.reference')"
                    />
                  </vxe-table>
                </fieldset>
              </el-col>
            </el-row>
          </div>
          <div class="form-footer">
            <el-button
              type="primary"
              size="medium"
              plain
              :loading="saveDoing"
              @click="saveSubmit"
              >{{ $t("text.submit") }}</el-button
            >
            <back-button />
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
import { page } from "@/utils/mixins.js";
import BackButton from "@/components/BackButton";
import TinymceEditor from "@/components/TinymceEditor";
import { referencesRentSlip, referencesRentItemSlip } from "@/utils/enums.js";
import PrintTemplate from "@/api/printTemplate.js";

export default {
  mixins: [page],
  components: { BackButton, TinymceEditor },
  data() {
    return {
      references: referencesRentSlip,
      referencesItem: referencesRentItemSlip,
      printTemplate: {
        name: null,
        content: "",
        type: "rent",
      },
      saveDoing: false,
    };
  },

  computed: {},
  created() {
    const self = this;
    self.loadingStart();
    PrintTemplate.findById(self.$route.params.id).then(function (res) {
      if (res.data.code === 200) {
        self.printTemplate = res.data.entity;
        self.loadingEnd();
      } else {
        self.sysError();
      }
    });
  },
  methods: {
    saveSubmit() {
      const self = this;
      this.$refs.printTemplateForm.validate((valid) => {
        if (valid) {
          self.saveDoing = true;
          PrintTemplate.update(self.printTemplate.id, self.printTemplate).then(
            function (res) {
              self.saveDoing = false;
              if (res.status === 200) {
                self.$message({
                  message: self.$t("prompt.editSuccess"),
                  type: "success",
                });
                self.$router.push({ name: "perferenceRentTemplates" });
              } else {
                self.sysError();
              }
            }
          );
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>